<template>
    
</template>

<script>
    export default {
        name: "Table"
    }
</script>

<style scoped>

</style>